var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "b-cont",
    },
    [
      _c("div", { staticClass: "detail-box" }, [
        _c("div", { staticClass: "detail-item" }, [
          _c("label", { staticClass: "detail-label" }, [_vm._v(" 产品图片")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail" },
            [
              _c(
                "flexbox",
                { staticClass: "detail-images" },
                [
                  _vm._l(_vm.primaryList, function (item, index) {
                    return _c("div", { key: index, staticClass: "show-img" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "src",
                            rawName: "v-src",
                            value: item.path || item.file_path,
                            expression: "item.path||item.file_path",
                          },
                        ],
                        key: item.path,
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "img-model" }, [
                        _c("i", {
                          staticClass: "el-icon-zoom-in set-img-zoom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.previewImage(_vm.primaryList, index)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-delete set-img-delete",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.deleteImg("main", index)
                            },
                          },
                        }),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.primaryList.length < 9
                    ? _c(
                        "div",
                        {
                          staticClass: "content-cross",
                          on: {
                            click: function ($event) {
                              return _vm.upLoadImg("main")
                            },
                          },
                        },
                        [
                          _c("input", {
                            ref: "primaryImgInput",
                            staticClass: "file-input",
                            attrs: {
                              accept: "image/*",
                              type: "file",
                              multiple: "",
                            },
                            on: { change: _vm.upLoad },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            staticClass: "cross",
                            attrs: { type: "text", icon: "el-icon-plus" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "detail-tip" }, [
                _vm._v("图片建议上传：290（宽） * 220(高) （最多只能上传"),
                _c("span", [_vm._v(_vm._s(9 - _vm.primaryList.length))]),
                _vm._v("张图片）"),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-box" }, [
        _c("div", { staticClass: "detail-item" }, [
          _c("label", { staticClass: "detail-label" }, [
            _vm._v(" 产品详情图片"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail" },
            [
              _c(
                "flexbox",
                { staticClass: "detail-images" },
                [
                  _vm._l(_vm.detailList, function (item, index) {
                    return _c("div", { key: index, staticClass: "show-img" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "src",
                            rawName: "v-src",
                            value: item.path || item.file_path,
                            expression: "item.path||item.file_path",
                          },
                        ],
                        key: item.path,
                        staticClass: "cross-two",
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "img-model" }, [
                        _c("i", {
                          staticClass: "el-icon-zoom-in set-img-zoom",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.previewImage(_vm.detailList, index)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-delete set-img-delete",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.deleteImg("detail", index)
                            },
                          },
                        }),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.detailList.length < 9
                    ? _c(
                        "div",
                        {
                          staticClass: "content-cross cross-two",
                          on: {
                            click: function ($event) {
                              return _vm.upLoadImg("detail")
                            },
                          },
                        },
                        [
                          _c("input", {
                            ref: "detailImgInput",
                            staticClass: "file-input",
                            attrs: {
                              accept: "image/*",
                              type: "file",
                              multiple: "",
                            },
                            on: { change: _vm.upLoad },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            staticClass: "cross",
                            attrs: { type: "text", icon: "el-icon-plus" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "detail-tip" }, [
                _vm._v("图片建议上传：750(宽) * 600(高)（最多只能上传"),
                _c("span", [_vm._v(_vm._s(9 - _vm.primaryList.length))]),
                _vm._v("张图片）"),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }